export const FooterCardComponents = [
    {
        id: 1,
        path: "/Despre-noi",
        title: "Despre noi",
    },
    {
        id: 2,
        path: "/Avantajele-clientilor",
        title: "Avantajele clientilor",
    },
    {
        id: 3,
        path: "/Confidentialitate",
        title: "Confidentialitate"
    },
    {
        id: 4,
        path: "/Termeni-si-conditii",
        title: "Termeni si conditii",
    },
    {
        id: 5,
        path: "/Detalii-Contact",
        title: "Detalii Contact",
    },
    {
        id: 6,
        path: "/login",
        title: "Creeaza cont",
    },
    {
        id: 7,
        path: "/Program-de-fidelitate",
        title: "Program de fidelitate",
    },
    {
        id: 8,
        path: "/login",
        title: "Am uitat parola",
    },
    {
        id: 9,
        path: "/Cum-cumpar",
        title: "Cum cumpar",
    },
    {
        id: 10,
        path: "/Cum-platesc",
        title: "Cum platesc",
    },
    {
        id: 11,
        path: "/Florariile-Floris",
        title: "Florariile Floris",
    },
    {
        id: 12,
        path: "/Informatii-despre-livrare",
        title: "Informatii despre livrare",
    },
    {
        id: 13,
        path: "/Politica-de-returnare",
        title: "Politica de returnare",
    },
    {
        id: 14,
        path: "/f-a-q",
        title: "F.A.Q.",
    },
    {
        id: 15,
        path: "https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO?ref=footer_4_5",
        title: "",
    },
    {
        id: 16,
        path: "https://anpc.ro/",
        title: "",
    },
    {
        id: 17,
        path: "/Fii-partener-Floris",
        title: "Fii partener Floris",
    },
]